import script from "./button.vue?vue&type=script&setup=true&lang=js"
export * from "./button.vue?vue&type=script&setup=true&lang=js"

import "./button.vue?vue&type=style&index=0&id=e9e42e22&lang=scss"

const __exports__ = script;

export default __exports__